import { AssetConfig } from "../index";

export const FleetOperatorConfig: AssetConfig = {
    employeeCode: {type: "STRING", required: false, editable: true, label: "Employee code", rank: 1},
    fullName: {type: "STRING", required: true, editable: true, label: "Full name", rank: 1},
    identification: {type: "STRING", required: false, editable: true, label: "Identification", rank: 1},
    nickName: {type: "STRING", required: false, editable: true, label: "Nickname", rank: 1},
};